import { ISortConfig } from "@/components/molecules/table/header/types";
import { TableConfig } from '@/components/molecules/table/types';
import Status from '@/enum/Status';
import { IRequest } from '@/services/api/models';
import { getStatusLabel, getStatusVariant } from '../../utils/helpers';
import { RequestColumnKeys, RequestTableProps } from './types';

export const DEFAULT_SORT: ISortConfig = {
    col: 'requests.status',
    dir: 'desc' as const,
};

const getTableConfig = ({ statuses, requestsService }: RequestTableProps): TableConfig<IRequest, RequestColumnKeys> => ({
    code: {
        label: "Codigo",
        value: (request: IRequest) => ({
            value: request.code
        })
    },
    status: {
        label: "Estado",
        isSortable: true,
        sortKey: "requests.status",
        value: (request: IRequest) => ({
            badge: {
                label: getStatusLabel(statuses, request.status),
                variant: getStatusVariant(request.status)
            }
        })
    },
    insured_fullname: {
        label: "Asegurado",
        value: (request: IRequest) => ({
            value: request.requests_details[0] ? request.requests_details[0].insured_fullname : '-',
        })
    },
    address: {
        label: "Dirección",
        value: (request: IRequest) => ({
            value: request.requests_details[0] ? request.requests_details[0].address : '-',
        })
    },
    netpayment: {
        label: "Prima Neta",
        value: (request: IRequest) => ({
            value: String(request.requests_details[0] ? request.requests_details[0].netpayment : 0).formatMoney(),
        })
    },
    original_gross_bonus: {
        label: "Prima bruta cedida",
        value: (request: IRequest) => ({
            value: String(request.requests_details[0] ? request.requests_details[0].original_gross_bonus : 0).formatMoney(),
        })
    },
    validity: {
        label: "Vigencia de la Póliza",
        value: (request: IRequest) => ({
            value: `${request.validity_from} - ${request.validity_to}`,
        })
    },
    actions: {
        label: "Acciones",
        value: (request: IRequest) => ({
            dropdown: {
                label: "⋮",
                items: [
                    [Status.Preaprobado, Status.Pendiente].includes(request.status)
                        ? { label: "Cotizar", route: `/requests/${request.id}/quote` }
                        : null,
                    request.status === Status.Cotizado
                        ? { label: "Orden en firme", onClick: () => requestsService.processRequest(request.id) }
                        : null,
                    request.status === Status.Cotizado
                        ? { label: "Declinar", onClick: () => requestsService.rejectRequest(request.id) }
                        : null,
                    { label: "Detalle", route: `/requests/${request.id}/detail` },
                ].filter(Boolean),
            },
        })
    },
});

export default getTableConfig;